export default {
    webview: 'sessions/webview'
}
